import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=7d009191"
import script from "./UiSelect.vue?vue&type=script&lang=ts"
export * from "./UiSelect.vue?vue&type=script&lang=ts"
import style0 from "./UiSelect.vue?vue&type=style&index=0&id=7d009191&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports